import Swiper from 'swiper';


export default () => {
	const settings = {
		spaceBetween: 16,
		breakpoints: {
			768: {
				slidesPerView: 2,
			}
		},
		slidesPerView: 1,
		keyboard: {
			enabled: true,
		},
		pagination: {
			el: '.swiper-pagination',
			clickable: true,
		},
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
		watchOverflow: true
	};

	// eslint-disable-next-line no-new
	new Swiper('.js-ch-latest-articles', settings);
};
